export default {
  namespaced: true,
  state: {
    url: `/api/creative/folders`,
    folders: []
  },
  getters: {
    getCreativeFolders: state => state.folders,
    getCreativeFolderById: state => id =>
      state.folders.find(folder => folder._id === id)
  },
  mutations: {
    setCreativeFolders: (state, data) => {
      state.folders = _.map(data, item => {
        return item;
      });
    },
    insertCreativeFolder: (state, data) => {
      state.folders.push(data);
    },
    updateCreativeFolderById: (state, { id, data }) => {
      let index = state.folders.findIndex(folder => folder._id === id);
      // delete or update item of array
      if (data.is_archived) {
        state.folders.splice(index, 1);
      } else {
        state.folders[index] = _.assign(state.folders[index], data);
      }
    }
  },
  actions: {
    async getCreativeFolders({ commit, state }) {
      try {
        let res = await axios.get(state.url);
        commit("setCreativeFolders", res.data);
      } catch (e) {
        throw e;
      }
    },
    async getCreativeFolderById({ commit, state }, id) {
      try {
        let res = await axios.get(`${state.url}/${id}`);
        commit("insertCreativeFolder", res.data);
      } catch (e) {
        throw e;
      }
    },
    async createCreativeFolder({ commit, state }, setObj) {
      try {
        let res = await axios.post(state.url, setObj);
        commit("insertCreativeFolder", res.data);
      } catch (e) {
        throw e;
      }
    },
    async updateCreativeFolderById(
      { commit, state },
      { id, setObj }
    ) {
      try {
        await axios.put(`${state.url}/${id}`, setObj);
        commit("updateCreativeFolderById", { id: id, data: setObj });
      } catch (e) {
        throw e;
      }
    },
    async patchCreativeFolderById(
      { commit, state },
      { id, setObj }
    ) {
      try {
        await axios.patch(`${state.url}/${id}`, setObj);
        commit("updateCreativeFolderById", { id: id, data: setObj });
      } catch (e) {
        throw e;
      }
    }
  }
};
